import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'
import { Skeleton } from '~/components/shared'

export const ContainerLoad = styled.div`
  position: relative;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`
export const ContentInLine = styled.div`
  display: flex;
  flex-direction: row;
`

export const Container = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  position: relative;
  width: 100%;
  height: calc(100vh - 56px);

  padding: 0 20px 20px 20px;

  display: flex;
  flex-direction: column;
  overflow-y: scroll;

  padding-right: 4px;
  ${VerticalStyledScrollBar}
`

export const MessageError = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  align-self: center;
  margin: auto 0;
`
